/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, April 20th 2023, 8:10:01 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Stack from "@mui/material/Stack";
import { useSubscriptionContext } from "saas-subscription/providers";
import { StyledOSDialog, OSMarketingBanner, EmphasisText } from "ui-widgets";
import { SubscriptionPlans } from "./SubscriptionPlans";

interface IUpgradeModalProps
  extends Pick<Required<React.ComponentProps<typeof StyledOSDialog>>, "renderOpenButton">,
    Pick<React.ComponentProps<typeof SubscriptionPlans>, "toShowCodes"> {}

export const UpgradeModal = ({ renderOpenButton, toShowCodes }: IUpgradeModalProps) => {
  const { subscriptionPlanName } = useSubscriptionContext();
  return (
    <StyledOSDialog renderOpenButton={renderOpenButton} maxWidth="xl">
      <Stack direction="column" spacing={4} sx={{ paddingTop: 4 }}>
        <OSMarketingBanner
          title={<>Take your organization a notch higher</>}
          subTitle={
            <>
              Upgrading gives your access to advanced features, more storage and better support. You are currently on
              the <EmphasisText>{subscriptionPlanName}</EmphasisText> plan.
            </>
          }
        />
        <SubscriptionPlans toShowCodes={toShowCodes} />
      </Stack>
    </StyledOSDialog>
  );
};
